module.exports = __webpack_public_path__ + "img/save.68d23611.svg";